<template>
  <div id="app">
    <keep-alive include="MonitoringCenter">
      <router-view/>
    </keep-alive>
    <GlobalAiSidebar v-if="shouldShowAiAssistant"/>
  </div>
</template>

<style>
/* main.css or App.vue <style> */
:root {
  --z-navbar: 3000;
  --z-dropdown: 3100;
  --z-modal: 3200;
  --z-tooltip: 3300;
  --z-loading: 3400;
}
</style>
<script>
import GlobalAiSidebar from '@/components/GlobalAiSidebar.vue';

export default {
  name: 'App',
  components: {
    GlobalAiSidebar
  },
  computed: {
    shouldShowAiAssistant() {
      const route = this.$route;
      if (!route || !route.path) {
        return false;
      }
      const path = route.path;
      if (path.indexOf('/front') === 0) {
        return true;
      }
      if (path === '/DataPlatform') {
        return true;
      }
      return false;
    }
  }
};
</script>
